// Create circular avatars with white borders - optimized for map markers
export const createCircularAvatar = (imageUrl, size = 50) => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    
    canvas.width = size;
    canvas.height = size;
    
    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = () => {
      // Create circular clipping path
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2 - 2, 0, 2 * Math.PI);
      ctx.closePath();
      ctx.clip();
      
      // Draw the avatar image
      ctx.drawImage(img, 0, 0, size, size);
      
      // Add white border (reset clipping first)
      ctx.globalCompositeOperation = 'source-over';
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2 - 1, 0, 2 * Math.PI);
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 2;
      ctx.stroke();
      
      resolve(canvas.toDataURL('image/png'));
    };
    
    img.onerror = () => resolve('/static/placeholder.png');
    img.src = imageUrl;
  });
};

// Cache processed avatars for performance
const avatarCache = new Map();

export const getCircularAvatar = async (imageUrl, size = 50) => {
  const cacheKey = `${imageUrl}-${size}`;
  
  if (avatarCache.has(cacheKey)) {
    return avatarCache.get(cacheKey);
  }
  
  const circularUrl = await createCircularAvatar(imageUrl, size);
  avatarCache.set(cacheKey, circularUrl);
  
  return circularUrl;
};
